import { render, staticRenderFns } from "./DropdownTag.vue?vue&type=template&id=5d165b08&"
import script from "./DropdownTag.vue?vue&type=script&lang=js&"
export * from "./DropdownTag.vue?vue&type=script&lang=js&"
import style0 from "./DropdownTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports